// Máscaras e helpers para campos brasileiros

export function onlyDigits(v = "") {
  return String(v).replace(/\D/g, "");
}

// CPF: 000.000.000-00
export function maskCPF(v = "") {
  const d = onlyDigits(v).slice(0, 11);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`;
  if (d.length <= 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
}

// RG (formato genérico BR): 00.000.000-0 (aceita X final ao digitar)
export function maskRG(v = "") {
  // preserva possível dígito verificador "X" no fim
  const raw = String(v).toUpperCase().replace(/[^0-9X]/g, "").slice(0, 9);
  if (!raw) return "";
  const body = raw.slice(0, -1).replace(/[^0-9]/g, "");
  const last = raw.slice(-1);
  const combined = body + last;
  const d = combined.slice(0, 9);
  if (d.length <= 2) return d;
  if (d.length <= 5) return `${d.slice(0, 2)}.${d.slice(2)}`;
  if (d.length <= 8) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5)}`;
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}-${d.slice(8)}`;
}

// Telefone: (00) 00000-0000 ou (00) 0000-0000
export function maskPhone(v = "") {
  const d = onlyDigits(v).slice(0, 11);
  if (d.length === 0) return "";
  if (d.length <= 2) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}

// CEP: 00000-000
export function maskCEP(v = "") {
  const d = onlyDigits(v).slice(0, 8);
  if (d.length <= 5) return d;
  return `${d.slice(0, 5)}-${d.slice(5)}`;
}

// Consulta ViaCEP (retorna { logradouro, bairro, cidade, estado } ou null)
export async function fetchCEP(cep) {
  const d = onlyDigits(cep);
  if (d.length !== 8) return null;
  try {
    const res = await fetch(`https://viacep.com.br/ws/${d}/json/`);
    if (!res.ok) return null;
    const data = await res.json();
    if (data.erro) return null;
    return {
      logradouro: data.logradouro || "",
      bairro: data.bairro || "",
      cidade: data.localidade || "",
      estado: (data.uf || "").toUpperCase(),
      complemento: data.complemento || "",
    };
  } catch {
    return null;
  }
}
